import Box from "@mui/material/Box";
import { alpha } from "@mui/material/styles";
import { InfoBannerProps } from "types";

const InfoBanner = ({ children }: InfoBannerProps) => (
  <Box
    sx={(theme) => ({
      mb: "1rem",
      p: "0.75rem",
      borderRadius: `${theme.shape.borderRadius}px`,
      fontSize: "0.875rem",
      textAlign: "center",
      bgcolor: alpha(theme.palette.info.main, 0.15),
      color: theme.palette.info.main,
    })}
  >
    {children}
  </Box>
);

export default InfoBanner;
